export const ACTION_CODE = 'DASHBOARD_CONSULTANT_SALES' + '_ACTION';
